<template>
  <div>
    <div v-if="loading">
      <v-container fluid grid-list-md>
        <v-layout row justify-center>
          <v-flex xs12 sm6 md4 lg3>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div v-else id="report-div">
      <email-dialog
        :emails="emails"
        :dialog="emailDialog"
        :subject="emailSubject"
        :body="emailBody"
        @dialog-set="emailDialog = $event"
        @sendmail="sendEmail"
      />
      <v-divider></v-divider>
      <div style="margin-top: 10px">
        <v-flex>
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="success" dark style="margin-right: 10px">
                <v-icon>file_download</v-icon>
                {{ $t("globals.download") }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="downloadExcel()">
                <v-list-item-title>
                  {{ $t("components.getreports.excel") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadPdf()">
                <v-list-item-title>
                  {{ $t("components.getreports.pdf") }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            color="primary"
            dark
            @click="emailDialog = true"
            style="margin-right: 10px"
          >
            <v-icon>email</v-icon>
            {{ $t("globals.send") }}
          </v-btn>
        </v-flex>
      </div>
      <v-row>
        <v-col sm12>
          <iframe
            :src="pdfFileLink"
            style="height: 500px; width: 100%; border: none"
          ></iframe>
        </v-col>
      </v-row>
    </div>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { translate2 } from "../trans2";
import EmailDialog from "../components/EmailDialog";
export default {
  name: "payment-scheduled-report",
  components: {
    ErrorHandler,
    EmailDialog,
  },
  props: ["term", "reportId"],
  data() {
    return {
      emailBody: "",
      emails: [],
      emailDialog: false,
      loading: false,
      error: null,
      emailSubject: null,
      selected: {
        Employers: [],
        Stores: [],
      },
      broker: null,
      file: null,
      pdfFileLink: null,
    };
  },
  computed: {
    ...mapGetters("common", {
      settings: "settings",
      selectedPlan: "plan",
      brokerId: "brokerId",
    }),
  },
  watch: {
    contacts: {
      handler(c) {
        var groupedEmails = [];
        var inHouse = [];
        var external = [];
        for (var i = 0; i < c.length; i++) {
          if (c[i].IsInHouse) {
            inHouse.push({
              name: c[i].Name,
              email: c[i].Email,
              group: "In House",
            });
          } else {
            external.push({
              name: c[i].Name,
              email: c[i].Email,
              group: "External",
            });
          }
        }
        if (inHouse.length > 0) {
          groupedEmails.push({ header: "In House" });
          groupedEmails = groupedEmails.concat(inHouse);
        }
        if (external.length > 0) {
          groupedEmails.push({ header: "External" });
          groupedEmails = groupedEmails.concat(external);
        }
        this.emails = groupedEmails;
      },
    },
  },
  mounted() {
    this.tryGetReport();
  },
  methods: {
    ...mapActions("data", ["fetchFile"]),
    ...mapActions("transactions", ["getReport", "sendReportEmail"]),
    ...mapActions("plansMembers", ["getContacts", "getOrganizationById"]),
    async sendEmail({ email, attachments }) {
      email.sender = this.user;
      email.urls = [];
      email.filenames = [];

      if (attachments.indexOf("Pdf") > -1) {
        email.filenames.push(this.file.PDFName);
        email.urls.push(this.settings.APIURL + "pdfs/" + this.file.PDFName);
      }

      if (attachments.indexOf("Excel") > -1) {
        email.filenames.push(this.file.ExcelName);
        email.urls.push(this.settings.APIURL + "excels/" + this.file.ExcelName);
      }
      var that = this;
      try {
        await this.sendReportEmail(email);
        that.mailAlert.show = true;
        that.mailAlert.type = "success";
        that.mailAlert.text = this.$t("components.getreports.email_success");
      } catch (error) {
        error.clientCode = "getReportsMail";
        this.error = error;
      }
    },
    async tryGetReport() {
      this.loading = true;

      try {
        this.broker = (
          await this.getOrganizationById({
            id: this.brokerId,
          })
        ).data;

        this.emailSubject = this.$t(
          "components.getreports.email_subject_{0}_{1}_{2}",
          [
            translate2(this.selectedPlan, "Name"),
            this.$t("components.paymentschedulereport.PlanTermBalance"),
            translate2(this.term, "Name"),
          ]
        );

        this.emailBody = [
          this.$t("globals.hello"),
          this.$t("components.getreports.email_body_{0}_{1}_{2}_{3}", [
            this.$t("components.paymentschedulereport.PlanTermBalance"),
            translate2(this.selectedPlan, "Name"),
            translate2(this.term, "Name"),
          ]),
          "Kind regards,",
          this.broker.Name,
          this.displayAddress(this.broker),
          this.broker.Email,
        ].join("\n");
        // console.log(this.emailBody);
        await this.getPotentialContacts();
        this.file = (
          await this.getReport({
            payload: {
              PlanId: this.selectedPlan.Id,
              TermId: this.term.Id,
              ReportType: "PlanTermBalance",
              ReportId: this.reportId,
            },
          })
        ).data;
        this.pdfFileLink = this.settings.APIURL + "pdfs/" + this.file.PDFName;
        setTimeout(() => {
          document.getElementById("report-div").scrollIntoView({
            behavior: "smooth",
          });
        }, 750);
      } catch (error) {
        error.messageParams = ["PlanTermBalance"];
        this.error = error;
      }
      this.loading = false;
    },
    async getPotentialContacts() {
      try {
        this.contacts = (
          await this.getContacts({
            planId: this.selectedPlan.Id,
            filter: "IsInhouse eq true",
          })
        ).data.value;
      } catch (error) {
        this.error = error;
      }
    },
    displayAddress(obj) {
      let res = "";

      if (obj.SuiteNumber) {
        res += obj.SuiteNumber;
      }
      if (obj.StreetNumber) {
        if (res.length > 0) {
          res += ", ";
        }
        res += obj.StreetNumber.toString();
      }
      if (obj.StreetName) {
        if (res.length > 0) {
          res += ", ";
        }
        res += obj.StreetName;
      }
      if (res.length > 0) {
        res += ", ";
      }
      res += obj.City + ", " + obj.Province.Code;
      if (obj.PostalCode) {
        res += " " + obj.PostalCode;
      }
      return res;
    },
    async downloadPdf() {
      try {
        const response = await this.fetchFile({
          url: this.settings.APIURL + "pdfs/" + this.file.PDFName,
          filename: this.file.PDFName,
        });
        this.downloadBlob(new Blob([response.data]), this.file.PDFName);
      } catch (e) {
        console.error(e);
      }
    },
    async downloadExcel() {
      try {
        var response = await this.fetchFile({
          url: this.settings.APIURL + "excels/" + this.file.ExcelName,
          filename: this.file.ExcelName,
        });
        this.downloadBlob(new Blob([response.data]), this.file.ExcelName);
      } catch (e) {
        console.error(e);
      }
    },
    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      link.setAttribute("id", "link1");
      document.body.appendChild(link);
      link.click();
      var element = document.getElementById("link1");
      element.parentNode.removeChild(element);
    },
  },
};
</script>
